// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
// 语言检测当前已停用（后台默认中文）；恢复多语言时放开此 import 与 .use(LanguageDetector)
// import LanguageDetector from 'i18next-browser-languagedetector'
import axios from 'axios'

i18n

  // Enables the i18next backend
  .use(Backend)

  // 后台管理当前默认使用中文：不做浏览器/localStorage 语言检测，直接固定 zh
  // .use(LanguageDetector)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    // 固定中文（源码基准语言）；如需恢复多语言检测，放开 LanguageDetector 并移除 lng 即可
    lng: 'zh',
    fallbackLng: 'zh',

    // 支持的语言：中文 / English / Bahasa Indonesia
    supportedLngs: ['zh', 'en', 'id'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    backend: {
      /* translation file path */
      loadPath: `${process.env.PUBLIC_URL}/assets/data/locales/{{lng}}.json`
    },
    debug: false,
    keySeparator: false,
    nsSeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

// ** 全局 axios 附加 X-Lang 请求头，后端据此返回对应语言的消息（zh/en/id）。
// ** 覆盖未走 jwtService 拦截器的 axios 直用请求，并随语言切换同步更新。
const syncAxiosLang = lng => {
  axios.defaults.headers.common['X-Lang'] = 'zh'
}
syncAxiosLang('zh')
i18n.on('languageChanged', syncAxiosLang)

export default i18n
